// User pure for authentication purposes
export class APIUserDTO {
  id: number
  firstName: string
  surname: string
  email: string
  role: number
  dateAdded: Date
  lastLogin: Date
  isLive: boolean
  apiToken: string

  constructor(
    data: {
      id: number,
      firstName: string,
      surname: string,
      email: string,
      role: number,
      dateAdded: Date,
      lastLogin: Date,
      isLive: boolean,
      apiToken: string
    }) {
    this.id = data.id
    this.firstName = data.firstName
    this.surname = data.surname
    this.email = data.email
    this.role = data.role
    this.dateAdded = data.dateAdded
    this.lastLogin = data.lastLogin
    this.isLive = data.isLive
    this.apiToken = data.apiToken
  }
}